export default {
  address: [
    'user-input',
    'map',
    'highway',
    'underground',
  ],
  'about-object': [
    'common/cadastral-number',
    'settlement-name',
    'build-year',
    'material-type-house',
    'suburban-total-area',
    'floors-count-house',
    'bedrooms-count',
    'visual-divider',
    'wc-location-type',
    'heating-type-house',
    'repair-type',
    'in-house-rent',
    'visual-divider',
    'area-land',
  ],
  'price-and-deal-terms': [
    'price-rent',
    'utilities-terms',
    'visual-divider',
    'bargain',
    'prepay-type',
    'self-employed',
    'deposit',
    'fee',
  ],
};
